/*=========================================================================================
  File Name: mutations.js
  Namespace: exercises
  Description: Vuex Store - Exercise mutations
==========================================================================================*/
import {
  buildExerciseState
} from './state'

const mutations = {
  STORE_CURRENT_EXERCISE(state, exercise) {
    state.currentExercise = { ...state.currentExercise, ...exercise }
  },
  RESET_CURRENT_EXERCISE(state) {
    state.currentExercise = buildExerciseState()
  },
  STORE_LIST_EXERCISES(state, exercises) {
    state.exerciseList = {
      ...state.exerciseList,
      ...exercises.entries
    }
    state.count = exercises.count
    state.next = exercises.next
    state.previous = exercises.previous
    state.results = [...exercises.results]
  },
  STORE_EXERCISE_TO_LIST(state, exercise) {
    state.exerciseList = {
      ...state.exerciseList,
      ...exercise
    }
  },
  STORE_CURRENT_EXERCISE_FILES(state, files) {
    state.currentExerciseFiles = files
  },
  CHANGE_FILE_IN_EXERCISE(state, payload) {
    const fileChanged = state.currentExerciseFiles[state.currentExerciseFiles.indexOf(payload.file)]
    fileChanged.name = payload.name
    
  },
  RESET_FILES_IN_EXERCISE(state) {
    state.currentExerciseFiles = []
  },
  STORE_CURRENT_EXERCISE_CODE(state, code) {
    state.currentExercise.starter_code = code
  },
  STORE_CURRENT_EXERCISE_TEST(state, test) {
    state.currentTests = {
      ...state.currentTests,
      [test.id]: test
    }
  },
  STORE_CURRENT_EXERCISE_TESTS(state, tests) {
    state.currentTests = {...tests}
  },
  DELETE_TEST_FROM_EXERCISE(state, { testId, deleteFunc }) {
    deleteFunc(state.currentTests, testId)
  },
  STORE_CURRENT_EXERCISE_SOLUTION(state, solution) {
      state.currentSolutions = {
        ...state.currentSolutions,
        [solution.id]: solution
      }
    },
    STORE_CURRENT_EXERCISE_SOLUTIONS(state, solutions) {
      state.currentSolutions = {
        ...solutions
      }
    },
    DELETE_SOLUTION_FROM_EXERCISE(state, {
      solutionId,
      deleteFunc
    }) {
      deleteFunc(state.currentSolutions, solutionId)
    }
}

export default mutations

